/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const TransferredIncomingSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
    viewBox="0 0 8 10"
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
      d="M3.3 1.6h3.6v6.8H3.3v-1h-.6V9h4.8V1H2.7v1.6h.6v-1z"
    ></path>
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
      d="M5.656 4.437H.361a.063.063 0 00-.06.064v.477c0 .035.026.064.06.064h4.605L3.868 6.497c-.032.041-.003.103.048.103h.551a.121.121 0 00.097-.048l1.284-1.703c.125-.167.012-.412-.192-.412z"
    ></path>
  </svg>
);

const TransferredOutgoingSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
    viewBox="0 0 8 10"
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
      d="M4.3 1.6h3.6v6.8H4.3v-1h-.6V9h4.8V1H3.7v1.6h.6v-1z"
    ></path>
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
      d="M6.439 4.959H1.834l1.098-1.456c.032-.041.004-.103-.048-.103h-.551a.121.121 0 00-.096.048L.953 5.15c-.126.167-.012.412.191.412H6.44a.063.063 0 00.061-.064v-.477a.064.064 0 00-.062-.063z"
    ></path>
  </svg>
);

export const TransferredIncomingIcon = props => <Icon component={TransferredIncomingSvg} {...props} />;
export const TransferredOutgoingIcon = props => <Icon component={TransferredOutgoingSvg} {...props} />;

